import { render, staticRenderFns } from "./MdinEditAbout.vue?vue&type=template&id=3e9f132c&scoped=true&"
import script from "./MdinEditAbout.vue?vue&type=script&lang=js&"
export * from "./MdinEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f132c",
  null
  
)

export default component.exports